import React, { Fragment, useState } from "react";
import { Row, Col, Form, Input, Checkbox } from "antd";

import ModalComponent from "@/components/modal";

import "@/styles/pages/auth/create-account.scss";
import ButtonComponent from "@/components/button/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  getUserMobileNumber,
  setCurrentForm,
  setModalOpen,
  setToken,
} from "@/reducers/commonSlice";
import { createAccount } from "@/services/accounts/createAccount";
import { updateUserRole } from "@/services/users/updateUserRole";

const CreateAccount = ({ isOpen = false }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [checked, setChecked] = useState(false);

  const onCheckboxChange = async (e) => {
    await setChecked(e.target.checked);
    form.validateFields(["terms"]);
  };

  const userMobileNumber = useSelector(getUserMobileNumber);
  const handleFinish = (value) => {
    // console.log(value);
    createAccount({
      firstName: value.firstName,
      lastName: value.lastName,
      password: value.password,
      userName: value.userName,
      email: value.email,
      mobileNumber: userMobileNumber,
    })
      .then((response) => {
        console.log(response);
        dispatch(setToken(response.accessToken));
        localStorage.setItem("token", response.accessToken);
        const isApplyingForGuide = localStorage.getItem("isApplyingForGuide");
        if (isApplyingForGuide) {
          updateUserRole({
            userRole: "Guide",
          })
            .then((response) => {
              console.log(response);
              dispatch(setCurrentForm("guidePlatform"));
              dispatch(setModalOpen(true));
            })
            .catch((error) => {
              console.log(error);
            });
          localStorage.removeItem("isApplyingForGuide");
        } else {
          dispatch(setCurrentForm("registrationCategories"));
        }
        // updateUserRole({
        //   userRole: "Student",
        // })
        //   .then((response) => {
        //     console.log(response);
        //     dispatch(setCurrentForm("journeySelection"));
        //   })
        //   .catch((error) => {
        //     console.log(error)
        //   });
      })
      .catch((error) => {
        const errorMessage = error?.response?.data?.msg;
        console.log("errorMessage :: ", errorMessage);
        if (errorMessage) {
          switch (errorMessage) {
            case "User already exists":
              form.setFields([
                {
                  name: "email",
                  errors: ["Email already in use, please try a different email"],
                },
              ]);
            // case "Username already exists":
            //   form.setFields([
            //     {
            //       name: "userName",
            //       errors: ["Username already in use, please try a different username"],
            //     },
            //   ]);
              break;
          }
        }
      });
  };

  const validation = (rule, value, callback) => {
    if (checked) {
      return callback();
    }
    return callback("Please accept the terms and conditions");
  };

  return (
    <Fragment>
      <ModalComponent
        buttonLabel="Create Account"
        isOpen={isOpen}
        width={1257}
        maskClosable={false}
        className="onboarding-modal"
      >
        <div className="create-account-modal">
          <div className="card">
            <Row style={{ justifyContent: "space-between" }}>
              <Col xs={24} md={12}>
                <div className="title-h5 heading">
                  Let's quickly create <br /> <span>your account!</span>
                </div>
                <Form
                  name="register"
                  initialValues={{ remember: true }}
                  layout="vertical"
                  form={form}
                  onFinish={handleFinish}
                >
                  {/* <Form.Item
                    label="User Name"
                    name="userName"
                    rules={[
                      {
                        required: true,
                        message: "Please enter an username.",
                      },
                    ]}
                  >
                    <Input
                      onKeyPress={(event) => {
                        // Allow only letters, numbers, and underscores
                        if (!/[a-zA-Z0-9_]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      placeholder="Enter your username"
                    />
                  </Form.Item> */}
                  <Form.Item
                    label="First Name"
                    name="firstName"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your first name.",
                      },
                    ]}
                  >
                    <Input
                      onKeyPress={(event) => {
                        if (!/[a-zA-Z]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      placeholder="Enter your first name"
                    />
                  </Form.Item>

                  <Form.Item
                    label="Last Name"
                    name="lastName"
                    rules={[
                      {
                        required: true,
                        message: "Please enter your last name.",
                      },
                    ]}
                  >
                    <Input
                      onKeyPress={(event) => {
                        if (!/[a-zA-Z]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      placeholder="Enter your last name"
                    />
                  </Form.Item>

                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      {
                        type: "email",
                        required: true,
                        message: "Please enter a valid email address.",
                      },
                    ]}
                  >
                    <Input placeholder="Enter your email" />
                  </Form.Item>

                  <Form.Item
                    label="Password"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Password must be at least 8 characters long.",
                      },
                      {
                        min: 8,
                        message: "Password must be at least 8 characters long.",
                      },
                    ]}
                  >
                    <Input.Password placeholder="Enter New Password" />
                  </Form.Item>

                  <Form.Item name="terms" rules={[{ validator: validation }]}>
                    <Checkbox checked={checked} onChange={onCheckboxChange}>
                      By checking this box, I agree to the{" "}
                      <a href="/privacy-policy" target="_blank" className="color-brand">
                        Privacy Policy
                      </a>{" "}
                      and{" "}
                      <a href="/terms-and-condition" target="_blank" className="color-brand">
                        Terms & Conditions
                      </a>
                      .
                    </Checkbox>
                  </Form.Item>

                  <Form.Item>
                    <div className="button">
                      <ButtonComponent label="Continue" varient="primary" htmlType="submit" />
                    </div>
                  </Form.Item>
                </Form>
              </Col>

              <Col xs={0} md={11} className="image-col">
                <div className="image-container">
                  <img src="/assets/images/signup.svg" alt="College" className="responsive-image" />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </ModalComponent>
    </Fragment>
  );
};

export default CreateAccount;
